import { render, staticRenderFns } from "./TransferAllMachinesBtn.vue?vue&type=template&id=21df5f0b&scoped=true&"
import script from "./TransferAllMachinesBtn.vue?vue&type=script&lang=js&"
export * from "./TransferAllMachinesBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df5f0b",
  null
  
)

export default component.exports